import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { language } from 'Root/constants';
import { imageSet } from '../../../helper/Images';
import Context from '../../../context';
import Data from 'Content/content.json';
import Look from './Look';

import './LookList.scss';

const LookList = ({
  looks,
  selectedLensType,
  handleLooksChange,
  recommendedIndex,
  onLooksLoaded,
  currentLookIndex,
}) => {
  const {
    updateLooksLoaded,
    looksLoaded,
    product,
    updateLook,
    look,
    updateClearLooks,
    updateForceLookReset,
  } = useContext(Context);
  const {
    data: {
      productInfo: {
        [language]: { [selectedLensType]: lensList },
      },
    },
  } = Data;
  const [selected, setSelected] = useState(-1);
  const [recommended, setRecommended] = useState(-1);
  const [recommendedStar, setRecommendedStar] = useState(null);

  useEffect(() => {
    updateLooksLoaded();
    const isRecommended = recommendedIndex > -1;
    const lookKey = isRecommended
      ? lensList[recommendedIndex].recommended_look
      : lensList[product].recommended_look;
    let recommendedLook = looks.findIndex(({ icon }) => icon === lookKey);

    if (isRecommended) {
      setRecommended(recommendedLook);
      setRecommendedStar(imageSet[lensList[recommendedIndex]['star_img']]);
    }
    if (!looksLoaded) {
      setSelected(recommendedLook);
      updateLook(recommendedLook);
    } else {
      setSelected(look);
    }
    currentLookIndex === -1 && onLooksLoaded(recommendedLook);
  }, []);

  const handleLookChange = (selectedLook, index) => {
    updateClearLooks(false);
    updateForceLookReset(false);
    setSelected(index);
    handleLooksChange(selectedLook, index, 1);
    updateLook(index);
  };

  return (
    <ul className="palette--wrapper palette--looks">
      {looks.map((lookData, index) => (
        <Look
          key={index}
          index={index}
          selected={selected === index && true}
          recommended={recommended === index && true}
          look={lookData}
          recommendedStar={recommendedStar}
          language={language}
          onClick={(selectedLook) => handleLookChange(selectedLook, index)}
        />
      ))}
    </ul>
  );
};

LookList.propType = {
  looks: PropTypes.array,
  selectedLensType: PropTypes.string,
  handleLooksChange: PropTypes.func,
  recommendedIndex: PropTypes.number,
  onLooksLoaded: PropTypes.func,
  currentLookIndex: PropTypes.number,
};

export default LookList;
